"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6964],{

/***/ 75321:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var getFulfillmentCondition = function getFulfillmentCondition(fulfilledAfterDays) {
  return fulfilledAfterDays && (0, _fp.isNumber)(fulfilledAfterDays) && fulfilledAfterDays > 0 ? [{
    value: " after "
  }, {
    value: "".concat(fulfilledAfterDays)
  }, {
    value: ' days'
  }] : [];
};
var _default = exports["default"] = getFulfillmentCondition;
module.exports = exports.default;

/***/ }),

/***/ 58970:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _getFulfillmentCondition = _interopRequireDefault(__webpack_require__(75321));
var _getApplicableRewards3 = _interopRequireDefault(__webpack_require__(58237));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Returns portable text structure of the rewards you will receive.
 *
 * @param {object} opts - Arguments to be provided in object structure.
 * @param {object} opts.offer - Sanity offer object.
 * @param {object=} opts.rewards - Object with key as offerId and a value an array or reward ids.
 * @param {string=} opts.possession - Choice of "their", "your", etc when articularing the sentence.
 * @param {boolean} isList - Determines array structure to read items either as sentence or list. Disabled by default.
 * @returns {object[]} Array of portable text object structure sentence of rewards to be received.
 */

var PLUS = 'Plus,';
var getRewardsPortableText = function getRewardsPortableText(_ref) {
  var offer = _ref.offer,
    rewards = _ref.rewards;
  var isList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var applicableRewards = (0, _getApplicableRewards3["default"])({
    offer: offer,
    rewards: rewards
  });
  if ((0, _fp.isEmpty)(applicableRewards)) {
    return [];
  }
  var _getApplicableRewards = (0, _getApplicableRewards3["default"])({
      offer: offer,
      rewards: rewards
    }),
    _getApplicableRewards2 = _slicedToArray(_getApplicableRewards, 3),
    first = _getApplicableRewards2[0],
    second = _getApplicableRewards2[1],
    third = _getApplicableRewards2[2];
  var firstFulfillmentCondition = (0, _getFulfillmentCondition["default"])(first === null || first === void 0 ? void 0 : first.fulfilledAfterDays);
  var secondFulfillmentCondition = (0, _getFulfillmentCondition["default"])(second === null || second === void 0 ? void 0 : second.fulfilledAfterDays);
  var thirdFulfillmentCondition = (0, _getFulfillmentCondition["default"])(third === null || third === void 0 ? void 0 : third.fulfilledAfterDays);
  var rewardsStructure = isList ? [[{
    value: first.text
  }].concat(_toConsumableArray(firstFulfillmentCondition)), _toConsumableArray(second ? [{
    value: "".concat(PLUS, " ")
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition)) : []), _toConsumableArray(third ? [{
    value: "".concat(PLUS, " ")
  }, {
    value: third.text
  }].concat(_toConsumableArray(thirdFulfillmentCondition)) : [])] : [{
    value: first.text
  }].concat(_toConsumableArray(firstFulfillmentCondition), _toConsumableArray(third ? [{
    value: ', and '
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition), [{
    value: ". ".concat(PLUS, " ")
  }, {
    value: third.text
  }], _toConsumableArray(thirdFulfillmentCondition)) : []), [{
    value: '.'
  }], _toConsumableArray(second && !third ? [{
    value: " ".concat(PLUS, " ")
  }, {
    value: second.text
  }].concat(_toConsumableArray(secondFulfillmentCondition), [{
    value: '.'
  }]) : []));
  return rewardsStructure;
};
var _default = exports["default"] = getRewardsPortableText;
module.exports = exports.default;

/***/ }),

/***/ 3512:
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getTermsHref = function getTermsHref(offerIdentifier) {
  var isPartnerOffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isPartnerOffer) return "/offer/partner/".concat(offerIdentifier, "#terms");
  return "/offer/".concat(offerIdentifier, "#terms");
};
var _default = exports["default"] = getTermsHref;
module.exports = exports.default;

/***/ }),

/***/ 66002:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var conditionFilter = function conditionFilter(condition) {
  var identifier = condition.identifier,
    importance = condition.importance,
    name = condition.name;
  var slug = identifier === null || identifier === void 0 ? void 0 : identifier.current;
  var isHighImportance = importance === 'high';
  var isIncluded = !(0, _fp.includes)(slug, ['promo-code', 'join-end-date']);
  return isHighImportance && isIncluded && name ? {
    value: name
  } : null;
};
var _default = exports["default"] = conditionFilter;
module.exports = exports.default;

/***/ }),

/***/ 27399:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getSpecificConditionsGroupName = exports.getConditionsGroupName = void 0;
var _fp = __webpack_require__(78230);
var _conditionFilter = _interopRequireDefault(__webpack_require__(66002));
var _flatMapDeep = _interopRequireDefault(__webpack_require__(76661));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getConditionsName = function getConditionsName(offer, path) {
  return (0, _fp.head)((0, _fp.uniqBy)('value', (0, _flatMapDeep["default"])(offer, path, _conditionFilter["default"]))) || null;
};
var getConditionsGroupName = exports.getConditionsGroupName = function getConditionsGroupName(offer) {
  return getConditionsName(offer, 'offerTypes.hasConditionsGroup.containsConditions');
};
var getSpecificConditionsGroupName = exports.getSpecificConditionsGroupName = function getSpecificConditionsGroupName(offer) {
  return getConditionsName(offer, 'offerTypes.hasSpecificConditions');
};

/***/ }),

/***/ 59182:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _constants = __webpack_require__(13294);
var _formatDate = _interopRequireDefault(__webpack_require__(56999));
var _getTermsHref = _interopRequireDefault(__webpack_require__(3512));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getOfferEndSummary = function getOfferEndSummary(offer) {
  var _offer$release, _offer$identifier;
  if ((0, _fp.isNil)(offer)) return null;
  var offerEndDate = offer === null || offer === void 0 || (_offer$release = offer.release) === null || _offer$release === void 0 ? void 0 : _offer$release.endTime;
  var cta = offer === null || offer === void 0 ? void 0 : offer.detailsTeaser;
  var offerIdentifier = offer === null || offer === void 0 || (_offer$identifier = offer.identifier) === null || _offer$identifier === void 0 ? void 0 : _offer$identifier.current;
  var targetsSegments = offer === null || offer === void 0 ? void 0 : offer.targetsSegments;
  var isPartnerOffer = (0, _fp.some)(function (segment) {
    var _segment$identifier;
    return (segment === null || segment === void 0 || (_segment$identifier = segment.identifier) === null || _segment$identifier === void 0 ? void 0 : _segment$identifier.current) === _constants.TARGET_SEGMENT.PARTNER_LOOKING_FOR_PRIVATE_HEALTH_INSURANCE;
  }, targetsSegments);
  return {
    value: (0, _fp.compact)([offerEndDate && {
      value: "Offer ends ".concat((0, _formatDate["default"])(offerEndDate, {
        composition: 'd MMM yyyy'
      }), ".")
    }, offerEndDate && cta && {
      value: ' '
    }, cta && {
      value: cta,
      marks: [_objectSpread(_objectSpread({}, isPartnerOffer && {
        inNewTab: true
      }), {}, {
        href: (0, _getTermsHref["default"])(offerIdentifier, isPartnerOffer),
        type: 'link'
      })]
    }])
  };
};
var _default = exports["default"] = getOfferEndSummary;
module.exports = exports.default;

/***/ }),

/***/ 72679:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _constants = _interopRequireDefault(__webpack_require__(13294));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getPromoCodeDescription = function getPromoCodeDescription(offer) {
  var _offer$canBeRedeemedW, _promoCode$descriptio;
  var promoCode = offer === null || offer === void 0 || (_offer$canBeRedeemedW = offer.canBeRedeemedWithPromoCode) === null || _offer$canBeRedeemedW === void 0 ? void 0 : _offer$canBeRedeemedW[0];
  if (!promoCode) {
    return null;
  }
  var description = promoCode === null || promoCode === void 0 || (_promoCode$descriptio = promoCode.description) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio[0]) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio.children) === null || _promoCode$descriptio === void 0 || (_promoCode$descriptio = _promoCode$descriptio[0]) === null || _promoCode$descriptio === void 0 ? void 0 : _promoCode$descriptio.text;
  if (!(0, _fp.isEmpty)(description)) {
    return {
      value: description
    };
  }
  var codeType = (promoCode === null || promoCode === void 0 ? void 0 : promoCode.codeType) || _constants["default"].OFFER_CODE_TYPE.PROMO;
  return {
    value: "Enter ".concat(codeType, " code if you join online")
  };
};
var _default = exports["default"] = getPromoCodeDescription;
module.exports = exports.default;

/***/ }),

/***/ 52068:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _getConditionsName = __webpack_require__(27399);
var _getRewardsPortableText = _interopRequireDefault(__webpack_require__(58970));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getSubtext = function getSubtext(offer) {
  var isRewardsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var additionalConditions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if ((0, _fp.isNil)(offer)) return null;
  var conditions = (0, _getConditionsName.getConditionsGroupName)(offer);
  var specificConditions = (0, _getConditionsName.getSpecificConditionsGroupName)(offer);
  var rewardsList = [[{
    value: 'For '
  }, conditions && {
    value: (0, _fp.lowerCase)(conditions.value)
  }, conditions && specificConditions && {
    value: ' '
  }, specificConditions]].concat(_toConsumableArray((0, _getRewardsPortableText["default"])({
    offer: offer
  }, true)), [additionalConditions && [{
    value: additionalConditions
  }]]);
  var rewardsText = [conditions, specificConditions && {
    value: ' '
  }, specificConditions, {
    value: ' can get '
  }].concat(_toConsumableArray((0, _getRewardsPortableText["default"])({
    offer: offer
  })), [additionalConditions && {
    value: " ".concat(additionalConditions)
  }]);
  return {
    value: isRewardsList ? (0, _fp.compact)(rewardsList) : (0, _fp.compact)(rewardsText)
  };
};
var _default = exports["default"] = getSubtext;
module.exports = exports.default;

/***/ }),

/***/ 76661:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Iterates to a deep array in order to map each value of that deeper array.
 *
 * @param {object} object - Object with deeply nested arrays.
 * @param {string} path - "." delimited string path to navigate to inner array.
 * @param {Function} fn - Function to run when mapping over inner array.
 */
var _flatMapDeep = function flatMapDeep() {
  var object = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _fp.identity;
  var _split = (0, _fp.split)('.', path),
    _split2 = _toArray(_split),
    first = _split2[0],
    rest = _split2.slice(1);
  var mapped = (0, _fp.flatMap)(function (value) {
    return (0, _fp.isEmpty)(rest) ? fn(value) : _flatMapDeep(value, (0, _fp.join)('.', rest), fn);
  }, object === null || object === void 0 ? void 0 : object[first]);
  return (0, _fp.compact)(mapped);
};
var _default = exports["default"] = _flatMapDeep;
module.exports = exports.default;

/***/ }),

/***/ 56999:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _dateFns = __webpack_require__(2993);
var formatDate = function formatDate(date, options) {
  var composition = options === null || options === void 0 ? void 0 : options.composition;
  var dateStructure = composition || 'd MMM';
  return date ? (0, _dateFns.format)((0, _dateFns.parseISO)(date), dateStructure) : null;
};
var _default = exports["default"] = formatDate;
module.exports = exports.default;

/***/ }),

/***/ 35420:
/***/ (function(module, exports, __webpack_require__) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _imageUrl = _interopRequireDefault(__webpack_require__(6803));
var _getWindow2 = _interopRequireDefault(__webpack_require__(27203));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_PIXEL_RATIO = 1;
var imageUrlBuilder = function imageUrlBuilder(config) {
  return function (source) {
    var _getWindow$devicePixe, _getWindow;
    var devicePixelRatio = (_getWindow$devicePixe = (_getWindow = (0, _getWindow2["default"])()) === null || _getWindow === void 0 ? void 0 : _getWindow.devicePixelRatio) !== null && _getWindow$devicePixe !== void 0 ? _getWindow$devicePixe : DEFAULT_PIXEL_RATIO;
    return (0, _imageUrl["default"])({
      dataset: config.dataset,
      projectId: config.projectId
    }).image(source).auto('format') // raster formats will use webp where available instead of png/jpg.
    .dpr(Math.min(5, devicePixelRatio)) // Set device pixel ratio when available (2x/3x res for retina screens).
    .fit('max') // Don't enlarge images when source image is smaller than width/height.
    .quality(80).width(5) // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
    .height(5); // Set a tiny default, so we fail tiny and obvious instead of ruining performance.
  };
};
var _default = exports["default"] = imageUrlBuilder;
module.exports = exports.default;

/***/ }),

/***/ 27203:
/***/ (function(module, exports) {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : null;
};
var _default = exports["default"] = getWindow;
module.exports = exports.default;

/***/ }),

/***/ 14282:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _getallrewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(19722));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getEligibleRewards = (0, _getallrewards.default)('isEligible');
var _default = getEligibleRewards;


/***/ }),

/***/ 80336:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _getallrewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(19722));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getUpsellApplicableRewards = (0, _getallrewards.default)('isUpsellApplicable');
var _default = getUpsellApplicableRewards;


/***/ }),

/***/ 15237:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _definitions = /*#__PURE__*/ _interop_require_default(__webpack_require__(56950));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getDefinitionErrors = function(offer) {
    return (0, _fp.flow)((0, _fp.get)('offerTypes'), (0, _fp.map)(function(offerType) {
        var offerTypeId = (0, _fp.get)('identifier.current', offerType);
        if ((0, _fp.isNil)(offerTypeId)) {
            return {
                message: 'Missing offerType identifier'
            };
        }
        var offerTypeDefinition = _definitions.default[offerTypeId];
        if ((0, _fp.isNil)(offerTypeDefinition)) {
            return {
                message: 'Missing offerType definition',
                offerTypeId: offerTypeId
            };
        }
        // Only proceed if rewards are defined, sometimes we don't make that graphql call
        if ((0, _fp.isUndefined)(offerType.givesAccessToOneOfRewards)) {
            return null;
        }
        var rewardIds = (0, _fp.compact)((0, _fp.map)('identifier.current', offerType.givesAccessToOneOfRewards));
        // Not every offer type needs to have rewards (eg refer a friend (fnd, ref))
        if ((0, _fp.isEmpty)(rewardIds)) {
            return null;
        }
        var definitionRewardIds = (0, _fp.map)('id', offerTypeDefinition.rewards);
        var differenceRewardIds = (0, _fp.xor)(definitionRewardIds, rewardIds);
        if (!(0, _fp.isEmpty)(differenceRewardIds)) {
            return {
                definitionRewardIds: definitionRewardIds,
                differenceRewardIds: differenceRewardIds,
                message: 'Difference rewardIds',
                offerTypeId: offerTypeId,
                rewardIds: rewardIds
            };
        }
        return null;
    }), _fp.compact)(offer);
};
var _default = getDefinitionErrors;


/***/ }),

/***/ 50572:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _lodash = /*#__PURE__*/ _interop_require_default(__webpack_require__(96486));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getReleaseTimes = function(offer) {
    return {
        endTime: _lodash.default.get(offer, 'release.endTime', null),
        startTime: _lodash.default.get(offer, 'release.startTime', null)
    };
};
var _default = getReleaseTimes;


/***/ }),

/***/ 14984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _lodash = /*#__PURE__*/ _interop_require_default(__webpack_require__(96486));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getTargetSegments = function(offer) {
    return (0, _lodash.default)(offer).chain().get('targetsSegments').map('identifier.current').compact().value();
};
var _default = getTargetSegments;


/***/ }),

/***/ 2788:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
Object.defineProperty(exports, "default", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _lodash = /*#__PURE__*/ _interop_require_default(__webpack_require__(96486));
var _moment = /*#__PURE__*/ _interop_require_default(__webpack_require__(30381));
var _getreleasetimes = /*#__PURE__*/ _interop_require_default(__webpack_require__(50572));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var INCLUSIVE_A_EXCLUSIVE_B = '[)';
// Returns true if offer is active at either current datetime or effectiveDate (if passed in scenario).
var isActive = function(offer) {
    var scenario = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var effectiveDate = (0, _moment.default)(_lodash.default.get(scenario, 'effectiveDate', new Date()));
    var _getReleaseTimes = (0, _getreleasetimes.default)(offer), startTime = _getReleaseTimes.startTime, endTime = _getReleaseTimes.endTime;
    if (startTime && endTime) {
        return effectiveDate.isBetween(startTime, endTime, null, INCLUSIVE_A_EXCLUSIVE_B);
    }
    if (startTime) {
        return effectiveDate.isSameOrAfter(startTime);
    }
    if (endTime) {
        return effectiveDate.isBefore(endTime);
    }
    return true;
};
var _default = isActive;


/***/ }),

/***/ 40932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _fp = __webpack_require__(78230);
var _geteligiblerewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(14282));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isEligible = function(offer, param) {
    var productId = param.productId, scale = param.scale;
    return !(0, _fp.isEmpty)((0, _geteligiblerewards.default)(offer, {
        productId: productId,
        scale: scale
    }));
};
var _default = isEligible;


/***/ }),

/***/ 33873:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _lodash = /*#__PURE__*/ _interop_require_default(__webpack_require__(96486));
var _moment = /*#__PURE__*/ _interop_require_default(__webpack_require__(30381));
var _getreleasetimes = /*#__PURE__*/ _interop_require_default(__webpack_require__(50572));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Returns true if offer is expired at either current datetime or effectiveDate (if passed in scenario).
var isExpired = function(offer) {
    var scenario = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var effectiveDate = (0, _moment.default)(_lodash.default.get(scenario, 'effectiveDate', new Date()));
    var endTime = (0, _getreleasetimes.default)(offer).endTime;
    if (endTime) {
        return effectiveDate.isAfter(endTime);
    }
    return false;
};
var _default = isExpired;


/***/ }),

/***/ 22021:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _lodash = /*#__PURE__*/ _interop_require_default(__webpack_require__(96486));
var _fp = __webpack_require__(78230);
var _isactive = /*#__PURE__*/ _interop_require_default(__webpack_require__(2788));
var _gettargetsegments = /*#__PURE__*/ _interop_require_default(__webpack_require__(14984));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// An offer is deemed to be active if the following are true.
// - Is offer available (check release dates).
// - Does offer have the requested target segment?
// - If there are multiple offers that are available & have this segment, then the one that has the latest start date should be the one that is displayed.
// Discussion https://ahmhealthinsurance.slack.com/archives/CGPTKNTK5/p1585704050003000
var findActiveByTargetSegment = function(offers, targetSegment) {
    var scenario = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, _lodash.default)(offers).filter(function(offer) {
        return (0, _fp.includes)(_lodash.default.toLower(targetSegment), (0, _gettargetsegments.default)(offer));
    }).filter(function(offer) {
        return (0, _isactive.default)(offer, scenario);
    }).sortBy('release.startTime', '_createdAt').value() || null;
};
var _default = findActiveByTargetSegment;


/***/ })

}]);